import { useNavigate } from "react-router-dom";
import { Navbar, Nav, Button, Container } from "react-bootstrap";
import { HouseDoor, ClipboardCheck, ListCheck, Layers, BoxArrowRight, PersonCircle, PrinterFill } from "react-bootstrap-icons";
import { useEffect, useState } from "react";
import { fetchCurrentUser } from "../services/api";
import { getStoredUser, setSessionData } from "../utils/session";
import "./navbar.css";


export default function CustomNavbar({ activePage, setActivePage, onLogout, isAdmin }) {
    const navigate = useNavigate();

    const handleLogout = () => {
        if (typeof onLogout === "function") {
            onLogout();
            navigate("/login");
        } else {
            console.error("onLogout no está definido o no es una función");
        }
    };

    const [nombreUsuario, setNombreUsuario] = useState("");

    useEffect(() => {
        async function fetchNombre() {
            const localUser = getStoredUser();
            if (localUser?.nombre) {
                setNombreUsuario(localUser.nombre);
            }

            try {
                const userData = await fetchCurrentUser();
                if (userData?.nombre) {
                    setNombreUsuario(userData.nombre);
                    setSessionData(userData);
                }
            } catch (error) {
                console.warn("No se pudo consultar el usuario actual:", error);
            }
        }

        fetchNombre();
    }, []);


    return (
        <Navbar expand="xl" className="navbar-custom">
            <Container fluid>
                {/* Título a la izquierda */}
                <Navbar.Brand className="navbar-title">
                    <img
                        src="/img/iconb.png"
                        alt="Logo"
                        className="navbar-logo"
                    />
                    Sistema de Infracciones
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="basic-navbar-nav" className="custom-toggle" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="mx-auto nav-links">
                        <Nav.Link className={activePage === "infracciones" ? "active" : ""} onClick={() => setActivePage("infracciones")}>
                            <HouseDoor className="icon" /> Infracciones
                        </Nav.Link>
                        <Nav.Link className={activePage === "motivacion" ? "active" : ""} onClick={() => setActivePage("motivacion")}>
                            <ClipboardCheck className="icon" /> Motivación
                        </Nav.Link>
                        <Nav.Link className={activePage === "infractor" ? "active" : ""} onClick={() => setActivePage("infractor")}>
                            <ListCheck className="icon" /> Infractor/Vehículo
                        </Nav.Link>
                        <Nav.Link className={activePage === "fotografias" ? "active" : ""} onClick={() => setActivePage("fotografias")}>
                            <Layers className="icon" /> Fotografías
                        </Nav.Link>
                        {!isAdmin && (
                            <Nav.Link className={activePage === "misinfracciones" ? "active" : ""} onClick={() => setActivePage("misinfracciones")}>
                                <PrinterFill className="icon" /> Mis Infracciones
                            </Nav.Link>
                        )}
                        {isAdmin && (
                            <Nav.Link onClick={() => navigate('/adminpage')} className="admin-nav-link text-warning">
                                <PersonCircle className="icon" /> Administrar
                            </Nav.Link>
                        )}
                    </Nav>

                    <div className="user-section">
                        <div className="user-info">
                            <PersonCircle className="user-icon" />
                            <span className="user-name">{nombreUsuario}</span>
                        </div>
                        <Button className="logout-btn" onClick={handleLogout}>
                            <BoxArrowRight className="icon" /> Cerrar sesión
                        </Button>
                    </div>



                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}
